module.exports = __webpack_public_path__ + "img/logo-white.9cf74053.png";